<template>
  <v-card id="create">
    <v-container fluid>
      <p class="headline">新增保單資料</p>
      <div v-if="!submitted">
        <v-form ref="form" lazy-validation>
          <v-row class="mb-2">
            <!-- mb-2是下邊界 -->
            <v-col :lg="4">
              <agency-combo
                v-model="insurance_data.agency_company"
                label="代理商"
                :rules="[
                  (v) =>
                    !(v === null || v.name == '') || '請選擇/輸入代理商名稱',
                ]"
              >
              </agency-combo>
            </v-col>
            <v-col :lg="4">
              <salesman-combo
                v-model="insurance_data.salesman"
                label="業務員姓名"
                :rules="[
                  (v) =>
                    !(v === null || v.name == '') || '請選擇/輸入業務員名稱',
                ]"
              >
              </salesman-combo>
            </v-col>
          </v-row>
          <v-row>
            <v-col :lg="4">
              <insurance-company-combo
                v-model="insuranceCompany"
                :items="this.insuranceCompanies"
                label="保險公司"
                :rules="[
                  (v) =>
                    !(v === null || v.name == '') || '請選擇/輸入保險公司名稱',
                ]"
              >
              </insurance-company-combo>
            </v-col>
            <v-col :lg="4">
              <v-combobox
                v-model="insuranceProduct"
                label="保險商品名稱"
                :rules="[
                  (v) =>
                    !(v === null || v.name == '') || '請選擇/輸入保險商品名稱',
                ]"
                :items="insuranceProducts"
                item-text="name"
                required
                clearable
              ></v-combobox>
            </v-col>
            <v-col :lg="4">
              <v-text-field
                v-model="insurance_data.insurance_number"
                :rules="[(v) => !!v || '請填寫保單號碼']"
                label="保單號碼"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col :lg="4">
              <holder-combo
                v-model="holder"
                :items="holders"
                label="投保人姓名"
                :rules="[
                  (v) =>
                    !(v === null || v.name == '') || '請選擇/輸入投保人姓名',
                ]"
              >
              </holder-combo>
            </v-col>
            <v-col :lg="4">
              <v-menu
                v-model="holder_birthday_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="insurance_data.holder.birthday"
                    :rules="[(v) => !!v || '請填寫出生日期']"
                    label="出生日期"
                    prepend-icon="mdi-calendar"
                    :disabled="disableHolder"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="insurance_data.holder.birthday"
                  @input="holder_birthday_menu = false"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col :lg="4">
              <v-radio-group
                v-model="insurance_data.holder.sex"
                row
                label="性別"
                :disabled="disableHolder"
                :rules="[(v) => !!v || '請填寫性別']"
              >
                <v-radio label="男性" value="male"></v-radio>
                <v-radio label="女性" value="female"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col :lg="4">
              <city-autocomplete
                @changeVal="handleCityChange"
                label="城市"
                v-model="city"
                :disabled="disableHolder"
                :rules="[
                  (v) =>
                    !(v === null || v.name === null || v.name == '') ||
                    '請填寫縣市',
                ]"
              ></city-autocomplete>
            </v-col>
            <v-col :lg="4">
              <v-autocomplete
                label="區域/鄉鎮"
                v-model="township"
                :items="areas"
                item-text="name"
                :disabled="disableHolder"
                :rules="[
                  (v) =>
                    !(v === null || v.name === null || v.name == '') ||
                    '請填寫區域/鄉鎮',
                ]"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col :lg="4">
              <v-text-field
                v-model="insurance_data.holder.address"
                :rules="[(v) => !!v || '請填寫詳細地址']"
                label="詳細地址"
                :disabled="disableHolder"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col :lg="4">
              <v-text-field
                v-model="insurance_data.contribution_period"
                :rules="[(v) => !!v || '請填寫供款年期']"
                label="供款年期"
                type="number"
                required
              ></v-text-field>
            </v-col>
            <v-col :lg="4">
              <v-text-field
                v-model="insurance_data.period_fee"
                :rules="[(v) => !!v || '請填寫每期保費']"
                label="每期保費"
                type="number"
                required
              ></v-text-field>
            </v-col>
            <v-col :lg="4">
              <v-select
                v-model="insurance_data.currency_type"
                :items="currency_items"
                :rules="[(v) => !!v || '請選擇幣別']"
                label="幣別"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col :lg="3">
              <v-text-field
                v-model="insurance_data.beneficiary_name"
                :rules="[(v) => !!v || '請填寫受益人姓名']"
                label="受益人姓名"
                required
              ></v-text-field>
            </v-col>
            <v-col :lg="3">
              <v-text-field
                v-model="insurance_data.second_holder_name"
                label="後備/第二持有人姓名"
              ></v-text-field>
            </v-col>
            <v-col :lg="3">
              <v-text-field
                v-model="insurance_data.backup_holder_name"
                label="後備/第二受保人姓名"
              ></v-text-field>
            </v-col>
            <v-col :lg="3">
              <v-text-field
                v-model="insurance_data.loss_of_mobility"
                label="失去行動能力權益人士"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col :lg="4">
              <v-menu
                v-model="insured_date_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="insurance_data.insured_date"
                    label="投保日期"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="insurance_data.insured_date"
                  @input="insured_date_menu = false"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col :lg="4">
              <v-menu
                v-model="effective_date_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="insurance_data.effective_date"
                    label="供款期滿日期"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="insurance_data.effective_date"
                  @input="effective_date_menu = false"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col :lg="4">
              <v-text-field
                v-model="insurance_data.insured_name"
                :rules="[(v) => !!v || '請填寫被保險人姓名']"
                label="被保險人姓名"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="insurance_data.remarks"
                label="備註"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-btn color="success" class="mr-2" @click="saveInsuranceData"
            >建立資料</v-btn
          >
          <v-btn color="primary" @click="toList">返回列表</v-btn>
        </v-form>
      </div>
      <div v-else>
        <v-card class="mx-auto" max-width="400">
          <v-card-title> 保單資料建立成功! </v-card-title>
          <v-card-text>
            <v-row>
              <v-col align="left"
                >請點擊「繼續新增」以建立下一筆資訊；或點擊「返回列表」以檢視已建立資料。</v-col
              >
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col>
                <v-btn color="success" class="mb-2" @click="newInsuranceData"
                  >繼續新增</v-btn
                >
              </v-col>
              <v-col>
                <v-btn color="primary" @click="toList">返回列表</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </div>
    </v-container>
  </v-card>
</template>

<script>
//定義資料服務類別
import CommonDataService from "../../services/CommonDataService";
import InsuranceDataService from "../../services/InsuranceDataService";
import citydata from "@/services/citiesdata.json";

//定義介面元件
import CityAutocomplete from "../../components/CityAutocomplete";
import SalesmanCombo from "../../components/SalesmanCombo";
import HolderCombo from "../../components/HolderCombo";
import AgencyCombo from "../../components/AgencyCombo";
import InsuranceCompanyCombo from "../../components/InsuranceCompanyCombo";
import ComboBoxUtil from "../../utils/ComboBoxUtil";
import TypeCheckUtil from "../../utils/TypeCheckUtil";
export default {
  name: "add-insurancedata",
  components: {
    CityAutocomplete,
    SalesmanCombo,
    InsuranceCompanyCombo,
    HolderCombo,
    AgencyCombo,
  },
  data() {
    // data主要是用來定義本頁的view model
    return {
      insurance_id: null, //用這個值來判斷是新資料還是舊資料
      insurance_data: this.getEmptyInsuranceData(),
      currency_items: ["USD", "RMB", "HKD", "AUD", "CAD", "EUR"], //幣別選項
      message: "",
      submitted: false,
      insured_date_menu: false,
      effective_date_menu: false,
      holder_birthday_menu: false,
      city: { name: null, areas: [] }, //v-model for 城市
      township: { name: null, zip: null }, //v-model for 區域
      cityItemIdx: -1,
      insuranceCompanies: [], //從API取的的保險公司＋商品資料，要注入至保險公司元件
      insuranceCompany: { id: -1, name: "", insurance_products: [] }, //v-model for 保險公司
      insuranceProduct: { id: -1, name: "" }, //v-model for 保險商品
      holders: [], //從API取的投保人資料，要注入至投保人元件
      holder: {
        id: -1,
        name: "",
        birthday: "",
        sex: "",
        city: "",
        township: "",
        address: "",
        displaytext: "",
      }, //v-model for 投保人
      isHolderChanged: false, //用來處理變更投保人
    };
  },
  created() {
    this.findInsuranceCompanies();
    this.findHolders();
  },
  computed: {
    areas() {
      //console.log('computed-areas:this.city=')
      //console.log(this.city)
      //console.log('computed.areas, this.city.areas=')
      //console.log(this.city.areas)
      return this.city.areas;
    },
    insuranceProducts() {
      if (this.insuranceCompany === null) {
        return [];
      }
      return this.insuranceCompany.insurance_products;
    },
    disableHolder() {
      return this.holder.id >= 0;
    },
  },
  watch: {
    insuranceCompany: function () {
      if (this.insuranceCompany === null) {
        this.insurance_data.insurance_company.id = -1;
        this.insurance_data.insurance_company.name = "";
      } else {
        this.insurance_data.insurance_company.id =
          this.insuranceCompany.id === null ? -1 : this.insuranceCompany.id;
        this.insurance_data.insurance_company.name =
          this.insuranceCompany.name === null ? "" : this.insuranceCompany.name;
      }

      this.insuranceProduct = { id: -1, name: "" };
    },
    insuranceProduct(val) {
      this.insuranceProduct = ComboBoxUtil.getComboBoxModel(
        val,
        this.insuranceProducts,
        { id: -1, name: "" }
      );
      this.insurance_data.insurance_product.id = this.insuranceProduct.id;
      this.insurance_data.insurance_product.name = this.insuranceProduct.name;
    },
    holder(val) {
      //console.log(val,'watch-val')
      this.holder = ComboBoxUtil.getComboBoxModel(val, this.holders, {
        id: -1,
        name: "",
        birthday: "",
        sex: "",
        city: "",
        township: "",
        address: "",
        displaytext: "",
      });
      if (this.holder.displaytext == "") {
        if (this.holder.id === -1) {
          //console.log('New Holder')
          this.holder.displaytext = this.holder.name;
        } else {
          this.holder.displaytext =
            this.holder.name + "(" + this.holder.birthday + ")";
        }
      }

      this.insurance_data.holder.id = this.holder.id;
      this.insurance_data.holder.name = this.holder.name;
      this.insurance_data.holder.birthday = this.holder.birthday;
      this.insurance_data.holder.sex =
        this.holder.sex != ""
          ? this.holder.sex
          : this.insurance_data.holder.sex;
      this.insurance_data.holder.address =
        this.holder.address != ""
          ? this.holder.address
          : this.insurance_data.holder.address;

      if (this.holder.city != "") {
        this.city = this.getCity(this.holder.city);
      }
      if (this.holder.township != "") {
        let filter = (element) => element.name === this.holder.township;
        this.townshipIdx = this.city.areas.findIndex(filter);
        this.township = this.city.areas[this.townshipIdx];
      }

      this.insurance_data.insured_name = this.holder.name;

      //console.log(this.insurance_data, 'watch-holder, this.insurance_data')

      this.isHolderChanged = true;
    },
    township: function () {
      if (TypeCheckUtil.isNullOrUndefined(this.township) == true) {
        this.insurance_data.holder.township = "";
        this.insurance_data.holder.zipcode = "";
      } else {
        var itemName = "";
        if (typeof this.township === "string") {
          itemName = this.township;
        } else {
          itemName = this.township.name;
        }
        let filter = (element) => element.name === itemName;
        this.townshipIdx = this.city.areas.findIndex(filter);

        //console.log('watch-township: townshipIdx=' + this.townshipIdx)
        //console.log(this.city, 'this.city')
        if (this.townshipIdx >= 0)
          this.township = this.city.areas[this.townshipIdx];
        if (TypeCheckUtil.isNullOrUndefined(this.township) == false) {
          this.insurance_data.holder.township = this.township.name;
          this.insurance_data.holder.zipcode = this.township.zip;
        }

        //console.log(this.insurance_data.holder,'watch-township: this.insurance_data.holder')
      }
    },
  },
  methods: {
    toList() {
      this.$router.push({ name: "insurancedata-list" });
    },
    getCity(name) {
      let filter = (element) => element.name === name;
      let idx = citydata.findIndex(filter);
      return citydata[idx];
    },
    findHolders() {
      //後續要重構，資料會越來越多
      CommonDataService.findHolders()
        .then((response) => {
          this.holders = response.list;
          // console.log(this.holders)
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    findInsuranceCompanies() {
      CommonDataService.findInsuranceCompanies()
        .then((response) => {
          this.insuranceCompanies = response.list;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    saveInsuranceData() {
      if (this.$refs.form.validate()) {
        //console.log('saveInsuranceData, this.insurance_data=')
        //console.log(this.insurance_data)
        //新增資料
        var data = {
          insurance_data: {
            agency_company: {
              id: this.insurance_data.agency_company.id,
              name: this.insurance_data.agency_company.name,
            },
            insurance_company: {
              id: this.insurance_data.insurance_company.id,
              name: this.insurance_data.insurance_company.name,
            },
            insurance_product: {
              id: this.insurance_data.insurance_product.id,
              name: this.insurance_data.insurance_product.name,
            },
            salesman: {
              id: this.insurance_data.salesman.id,
              name: this.insurance_data.salesman.name,
            },
            insurance_number: this.insurance_data.insurance_number,
            holder: {
              name: this.insurance_data.holder.name,
              birthday: this.insurance_data.holder.birthday,
              sex: this.insurance_data.holder.sex,
              city: this.insurance_data.holder.city,
              township: this.insurance_data.holder.township,
              address: this.insurance_data.holder.address,
              zipcode: this.insurance_data.holder.zipcode,
            },
            insured_date: this.insurance_data.insured_date,
            contribution_period: this.insurance_data.contribution_period,
            period_fee: this.insurance_data.period_fee,
            currency_type: this.insurance_data.currency_type,
            beneficiary_name: this.insurance_data.beneficiary_name,
            second_holder_name: this.insurance_data.second_holder_name,
            remarks: this.insurance_data.remarks,
            backup_holder_name: this.insurance_data.backup_holder_name,
            effective_date: this.insurance_data.effective_date,
            insured_name: this.insurance_data.insured_name,
            loss_of_mobility: this.insurance_data.loss_of_mobility,
          },
        };
        //console.log('saveInsuranceData, data=')
        //console.log(data);
        //呼叫建立資料的方法
        InsuranceDataService.create(data)
          .then((response) => {
            this.insurance_data = this.getEmptyInsuranceData();
            this.message = response.message;
            this.submitted = true;
          })
          .catch((e) => {
            console.log(e);
            this.$dialog.error({
              text: "建立失敗，請檢查保單號碼是否重覆",
              title: "Error",
            });
          });
      }
    },
    getEmptyInsuranceData() {
      return {
        id: null,
        agency_company: {
          id: -1,
          name: "",
        },
        insurance_company: {
          id: -1,
          name: "",
        },
        insurance_product: {
          id: -1,
          name: "",
        },
        salesman: {
          id: -1,
          name: "",
        },
        insurance_number: "",
        holder: {
          id: -1,
          name: "",
          birthday: "",
          sex: "",
          city: "",
          township: "",
          address: "",
          zipcode: "",
        },
        insured_date: "",
        contribution_period: 0,
        period_fee: 0,
        currency_type: "USD",
        beneficiary_name: "",
        second_holder_name: "",
        remarks: "",
        backup_holder_name: "",
        effective_date: "",
        insured_name: "",
        loss_of_mobility: "",
      };
    },
    newInsuranceData() {
      //清空表單
      this.submitted = false;
      this.insurance_id = null;
      this.message = "";
      this.township = { name: "", zip: "" };
      this.city = { name: null, areas: [] };
      //this.insurace_data = this.getEmptyInsuranceData();
      (this.insuranceCompanies = []), //從API取的的保險公司＋商品資料，要注入至保險公司元件
        (this.insuranceCompany = { id: -1, name: "", insurance_products: [] }), //v-model for 保險公司
        (this.insuranceProduct = { id: -1, name: "" }), //v-model for 保險商品
        this.findHolders();
      (this.holder = {
        id: -1,
        name: "",
        birthday: "",
        sex: "",
        city: "",
        township: "",
        address: "",
        displaytext: "",
      }), //v-model for 投保人
        this.findInsuranceCompanies();
    },
    handleCityChange(v) {
      //console.log('handleCityChange, v=')
      //console.log(v)
      if (v === null) {
        //console.log('handleCityChange, v === null')
        this.city = { name: null, areas: [] };
        //設定Model.city
        this.insurance_data.holder.city = "";
        this.insurance_data.holder.township = "";
        this.insurance_data.holder.zipcode = "";
      } else {
        this.city = v;
        //console.log('handleCityChange, city.name=' + this.city.name)
        //設定Model.city
        this.insurance_data.holder.city = this.city.name;

        //console.log('handleCityChange, city.areas=')
        //console.log(this.city.areas)
      }
      if (this.isHolderChanged == true) {
        this.isHolderChanged = false;
      } else {
        //因為城市變更了，所以要清空已選的區域
        this.township = { name: null, zip: null };
      }
    },
  },
};
</script>
<style scoped>
.submit-form {
  max-width: 300px;
}
</style>
